import { Component, OnInit, Inject, isDevMode } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { PROD_API_URL, DEV_API_URL } from '../../shared/global-vars';
import { IFilterUser } from '../../shared/shared.interface';

@Component({
  selector: 'app-dialog-filter-config',
  templateUrl: './dialog-filter-config.component.html',
  styleUrls: ['./dialog-filter-config.component.scss']
})
export class DialogFilterConfigComponent implements OnInit {
  api: string;
  filters: IFilterUser[];

  constructor(
    private http: HttpClient,
    public snack_bar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogFilterConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFilterUser[]
  ) {
    this.api = (isDevMode()) ? DEV_API_URL : PROD_API_URL;
    this.filters = this.data;
  }

  ngOnInit() {
    this.dialogRef.beforeClose().subscribe(() => {
      this.dialogRef.close(this.filters);
    });
  }

  visibility(filter_id: number, visibile: any){
    this.filters.map((filter) => {
      if (filter.id == filter_id) {
        let is_hidden = !visibile;
        this.http.patch(`${this.api}api/service/filters/${filter_id}/`, {is_hidden: is_hidden})
        .catch(err => {
          this.snack_bar.open('Server error, try later...', `Close`, { duration: 10000 });
          return Observable.throw(err);
        })
        .subscribe(response => {
          filter.is_hidden = is_hidden;
        });
      }
      return filter;
    });
  }

  remove(filter_id: number) {
    this.http.delete(`${this.api}api/service/filters/${filter_id}/`)
    .catch(err => {
      this.snack_bar.open('Server error, try later...', `Close`, { duration: 10000 });
      return Observable.throw(err);
    })
    .subscribe(response => {
      this.filters = this.filters.filter((filter) => filter.id != filter_id);
    });
  }

  shared(filter_id: number) {
    this.filters.map((filter) => {
      if (filter.id == filter_id) {
        let is_shared = !filter.is_shared;
        this.http.patch(`${this.api}api/service/filters/${filter_id}/`, {is_shared: is_shared})
        .catch(err => {
          this.snack_bar.open('Server error, try later...', `Close`, { duration: 10000 });
          return Observable.throw(err);
        })
        .subscribe(response => {
          filter.is_shared = is_shared;
        });
      }
      return filter;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-filter-config/dialog-filter-config.component.ts